export default function Divider(props) {
  return (
    <svg width="151" height="6" viewBox="0 0 151 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.613249 3L3.5 5.88675L6.38675 3L3.5 0.113249L0.613249 3ZM150.387 3L147.5 0.113249L144.613 3L147.5 5.88675L150.387 3ZM3.5 3.5H147.5V2.5H3.5V3.5Z" fill="#B8B8B8"/>
    </svg>    
  );
}
